module.exports = __webpack_public_path__ + "img/ly.3a00862f.png";